export default __webpack_public_path__ + "static/homepageLabs-6ed996557fc7af0b798f7f5e81f91035.svg";